import React, { useState, useEffect, useRef, useCallback } from 'react';
import { SESSION_TOAST_EVENT } from '../utils/sessionToast';
import classes from './SessionToastHost.module.css';

const DISPLAY_MS = 4200;

export default function SessionToastHost() {
    const [message, setMessage] = useState('');
    const [visible, setVisible] = useState(false);
    const hideTimerRef = useRef(null);
    const clearTimerRef = useRef(null);

    const hide = useCallback(() => {
        setVisible(false);
        if (clearTimerRef.current) clearTimeout(clearTimerRef.current);
        clearTimerRef.current = setTimeout(() => {
            setMessage('');
            clearTimerRef.current = null;
        }, 320);
    }, []);

    useEffect(() => {
        const handler = (e) => {
            const msg = e.detail?.message;
            if (!msg) return;
            if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
            if (clearTimerRef.current) clearTimeout(clearTimerRef.current);
            setMessage(msg);
            setVisible(true);
            hideTimerRef.current = setTimeout(() => {
                hide();
                hideTimerRef.current = null;
            }, DISPLAY_MS);
        };
        window.addEventListener(SESSION_TOAST_EVENT, handler);
        return () => {
            window.removeEventListener(SESSION_TOAST_EVENT, handler);
            if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
            if (clearTimerRef.current) clearTimeout(clearTimerRef.current);
        };
    }, [hide]);

    if (!message) return null;

    return (
        <div
            className={`${classes.toast} ${visible ? classes.toastVisible : classes.toastHidden}`}
            role="status"
            aria-live="polite"
        >
            {message}
        </div>
    );
}
